import { render, staticRenderFns } from "./create_service.vue?vue&type=template&id=5f255512&"
import script from "./create_service.vue?vue&type=script&lang=js&"
export * from "./create_service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports